import { FC } from 'react';
import './styles.css';

export const RectangleDown: FC = () => (
	<span className="rectangle-down--container">
		<span className="rectangle-down" />
	</span>
);
